import webpart from './webpart'
import page from './page'
import template from './template'
import board from './board'
import templateParts from './template-parts'
import personal from './personal'
import webpartData from './webpart-data'
import webpartBanner from './webpart-banner'
import shortcut from './shortcut'
import kyobobook from './kyobobook'
import graph from './graph'

export default {
    webpart,
    page,
    template,
    board,
    templateParts,
    personal,
    webpartData,
    webpartBanner,
    shortcut,
    kyobobook,
    graph
}
